// extracted by mini-css-extract-plugin
export default {"parentContainer":"bf_fp","slotHeader":"bf_fq","data":"bf_fr","operatorName":"bf_fs","averageRating":"bf_ft","extraRatings":"bf_fv"};